import React from "react";
import MuiFormControlLabel from "@mui/material/FormControlLabel";

import { FormControlLabelProps } from "./FormControlLabel.types";
import makeStyles from "@mui/styles/makeStyles";

export const useFormControlLabelStyles = makeStyles((theme) => ({
  root: {
    marginRight: 0,
    marginLeft: 0,
  },
  label: {
    marginLeft: 4,
    fontSize: 14,
    lineHeight: "18px",
    color: theme.palette.grey[900],
  },
}));

function FormControlLabel(props: FormControlLabelProps): JSX.Element {
  const { onChangeValue, onChange, ...other } = props;

  const formControlLabelClasses = useFormControlLabelStyles();

  const handleChange = (event: React.SyntheticEvent, checked: boolean) => {
    if (onChange) {
      onChange(event, checked);
    }
    if (onChangeValue) {
      onChangeValue(checked);
    }
  };

  delete other.helperText;
  delete other.error;

  return (
    <MuiFormControlLabel
      {...other}
      classes={formControlLabelClasses}
      onChange={handleChange}
    />
  );
}

export default FormControlLabel;
